import React from "react";
import Layout from "../components/Layout";
import usePageTitle from "../hooks/usePageTitle";
import Icon from "../components/Icon";
import InstallGuide from "../components/InstallGuide";
import "../styles/download.css";

/**
 * Страница «Скачать». 3 карточки: Windows, Android, iOS.
 * 2026-06-15: Windows-карточка активна — отдаёт установщик .exe
 * (Electron-обёртка rublox-desktop) по /download/Rublox-Setup.exe. Файл лежит
 * в persistent-папке /var/www/rublox-downloads/ на VM124 (nginx location
 * /download/), вне CI-управляемой build/. Android/iOS пока «в разработке».
 */
export default function DownloadPage() {
  usePageTitle("Скачать приложение");

  return (
    <Layout>
      <section className="rb-section">
        <div className="rb-container">
          <h1 className="rb-section__title">Скачать Рублокс</h1>
          <p className="rb-section__subtitle">
            Приложения для Windows и Android уже доступны — скачай и играй.
            Версия для iOS в разработке. Также можно играть прямо в браузере
            на rublox.pro — это бесплатно.
          </p>

          <div className="rb-dl__grid">
            {/* ── Windows (2026-06-15: установщик .exe готов к скачиванию) ── */}
            <div className="rb-dl__card">
              <div className="rb-dl__icon" aria-hidden>
                <Icon name="windows" size={44} />
              </div>
              <div className="rb-dl__platform">Windows</div>
              <div className="rb-dl__status rb-dl__status--ok">
                Доступно
              </div>
              <div className="rb-dl__meta">Windows 10 / 11</div>

              <a
                className="rb-btn rb-btn--primary rb-btn--block rb-btn--lg"
                href="/download/Rublox-Setup.exe"
                download
              >
                Скачать для Windows
              </a>

              <ul className="rb-dl__steps">
                <li>Скачайте установщик и запустите его</li>
                <li>
                  Если Windows покажет синее окно «Система Windows защитила
                  ваш компьютер» — нажмите <b>«Подробнее»</b>, затем{" "}
                  <b>«Выполнить в любом случае»</b>. Приложение безопасно.
                </li>
                <li>Студия и игры открываются прямо в приложении</li>
                <li>Вход — тем же логином, что и на сайте</li>
              </ul>
            </div>

            {/* ── Android (2026-06-15: APK готов — Capacitor WebView-обёртка) ── */}
            <div className="rb-dl__card">
              <div className="rb-dl__icon" aria-hidden>
                <Icon name="android" size={44} />
              </div>
              <div className="rb-dl__platform">Android</div>
              <div className="rb-dl__status rb-dl__status--ok">Доступно</div>
              <div className="rb-dl__meta">Android 7.0+</div>

              <a
                className="rb-btn rb-btn--primary rb-btn--block rb-btn--lg"
                href="/download/Rublox.apk"
                download
              >
                Скачать для Android
              </a>

              <ul className="rb-dl__steps">
                <li>Скачайте APK и откройте его</li>
                <li>Разрешите установку из этого источника</li>
                <li>Вход — тем же логином, что и на сайте</li>
              </ul>
            </div>

            {/* ── iOS ─────────────────────────────────────────────── */}
            <div className="rb-dl__card rb-dl__card--soon">
              <div className="rb-dl__icon" aria-hidden>
                <Icon name="apple" size={44} />
              </div>
              <div className="rb-dl__platform">iOS</div>
              <div className="rb-dl__status rb-dl__status--soon">Скоро</div>
              <div className="rb-dl__meta">iPhone и iPad</div>

              <button
                className="rb-btn rb-btn--ghost rb-btn--block rb-btn--lg"
                disabled
              >
                В разработке
              </button>

              <ul className="rb-dl__steps">
                <li>Версия для iOS появится позже</li>
                <li>Пока доступна только Android-версия</li>
              </ul>
            </div>
          </div>

          <InstallGuide />

          <div className="rb-dl__note">
            Аккаунт Рублокса — единый с онлайн-школой «Майнкрафтия». Войдите
            в приложении тем же логином, что и на сайте.
          </div>
        </div>
      </section>
    </Layout>
  );
}
